import { defineMessages } from 'react-intl';

export default defineMessages({
  noDataCaption: 'There are no proposals that match your search criteria.',
  noProposals: 'There are currently no proposals.',

  topVoters: 'Top voters',
  topProposers: 'Top proposers',
  proposals: 'Proposals',

  governanceFAQ: 'Governance FAQ',
  visitForum: 'Visit forum',
  visitSnapshots: 'Visit Snapshots',
});
